import React, { useEffect, useRef, useState } from 'react'
import './surveyForm.css';
import { useUserStore } from '../../../store/userStore';
import { saveSurveyApi } from '../../../api/survey';

import { useFieldArray, useForm } from 'react-hook-form';
import Swal from 'sweetalert2';
import { FaFileAlt } from "react-icons/fa";
import { getFileName } from '../../../utils/file/file';
import { swalErrorAlert } from '../../../utils/swal/swal';

const SurveyForm = ({ formInfo, savedFileList, setIsSubmit }) => {
  /* zustand */
  const { userInfo } = useUserStore(state => state)


  /* React Hook Form */
  const { register, handleSubmit, watch, setValue, reset, control } = useForm()
  useEffect(() => {
    reset(formInfo)
  }, [formInfo])


  // ✏️ 배열 관리 테스트 ...대박 ..!
  // const { fields, append, remove } = useFieldArray({
  //   control,
  //   name: "universities", // 배열로 관리
  // });


  /* File Upload */
  // 기존DB파일
  const [savedFiles, setSavedFiles] = useState([])
  const [deleteSavedFile, setDeleteSavedFile] = useState([])

  useEffect(() => {
    setSavedFiles(savedFileList)
  }, [savedFileList])

  const onClickDeleteSavedFile = (deleteItemPath) => {
    setSavedFiles((prevState) => { return prevState.filter((item) => item != deleteItemPath) })
    setDeleteSavedFile((state) => [...state, deleteItemPath])
  }

  // 새로업로드된파일
  const [newFiles, setNewFiles] = useState([])
  const fileInputRef = useRef(null);
  const files = watch("files");

  const handleFileInputChange = (event) => {
    const newFiles = Array.from(event.target.files); // 새로 선택한 파일 배열로 변환
    setNewFiles((prevFiles) => [...prevFiles, ...newFiles]); // 기존 목록에 추가

    event.target.value = ""; // 같은 파일 다시 선택 가능하게 초기화
  };

  const onClickDeleteFile = (deleteIndex) => {
    setNewFiles((prevFiles) => prevFiles.filter((_, i) => i !== deleteIndex));
  }


  /* Form Submit */
  const onSubmit = async (data) => {
    Swal.fire({
      title: '상담 신청서 제출',
      html: '상담 신청서를 제출하시겠습니까?',
      icon: 'question',
      showCancelButton: true, // 취소 버튼 표시
      confirmButtonText: '제출하기',
      cancelButtonText: '취소',
      reverseButtons: true, // 버튼 순서 변경
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          try {
            // ⚽ Validation

            // Api Data
            const userId = userInfo.user_id
            const formData = new FormData();

            if (newFiles && newFiles.length > 0) {
              newFiles.forEach((file) => {
                formData.append("fileData", file);
              });
            }

            let jsonData = {}
            Object.keys(data).forEach((key) => {
              if (key !== 'files') jsonData[key] = data[key]
            })
            formData.append("jsonData", JSON.stringify(jsonData))

            formData.append('deleteSavedFile', JSON.stringify(deleteSavedFile))

            const response = await saveSurveyApi(formData, userId)

            Swal.fire({
              title: "저장 완료",
              html: response.data.message,
              icon: "success",
              confirmButtonText: "확인",
              willClose: () => {
                window.scrollTo({ top: 0, behavior: "instant" }); // 스크롤 복구
              },
            }).then(async (result) => {
              if (result.isConfirmed) {
                setIsSubmit(true)
                window.location.reload(true);
              }
            });


          } catch (error) {
            // console.log(error);
            swalErrorAlert(
              "저장 실패",
              "저장 도중 에러가 발생했습니다.<br> 에러가 반복되면 관리자에게 문의해 주세요.",
              "error",
              "확인"
            )

          } finally {
            setNewFiles([])
            fileInputRef.current.value = ''
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: 'smooth'
            })
          }

        }
      })
  }

  return (
    <form className='survey-form' onSubmit={handleSubmit(onSubmit)}>

      <div className='mb-4'>
        <p className='text-danger'>* 표시는 필수 입력 항목입니다.</p>
      </div>

      <div className='mt-4 mb-4'>
        <label htmlFor="userName" className="form-label required mb-3">1. 학생 이름</label>
        <div className="input-group">
          <input type="text" {...register('userName')} id="userName" className="form-control" maxLength={30} autoComplete='off' placeholder='이름을 입력해주세요.' required />
        </div>
      </div>

      <div className='mb-4'>
        <label className="form-label required mb-3">2. 성별</label>
        <div className="input-group mb-5">
          <div className="me-5">
            <input type="radio" value={'남'} {...register("userSex")} id='userSexMale' className="form-check-input mt-0 me-2" required />
            <label htmlFor='userSexMale'>남</label>
          </div>
          <div className="me-5">
            <input type="radio" value={'여'} {...register("userSex")} id='userSexFemale' className="form-check-input mt-0 me-2" required />
            <label htmlFor='userSexFemale'>여</label>
          </div>
        </div>
      </div>

      <div className='mb-4'>
        <label className="form-label required mb-3">3. 학년</label>
        <div className="input-group mb-5">
          <div className="me-5">
            <input type="radio" value={'9학년'} {...register("userGrade")} id='userGradeNine' className="form-check-input mt-0 me-2" required />
            <label htmlFor='userGradeNine'>9학년</label>
          </div>
          <div className="me-5">
            <input type="radio" value={'10학년'} {...register("userGrade")} id='userGradeTen' className="form-check-input mt-0 me-2" required />
            <label htmlFor='userGradeTen'>10학년</label>
          </div>
          <div className="me-5">
            <input type="radio" value={'11학년'} {...register("userGrade")} id='userGradeEleven' className="form-check-input mt-0 me-2" required />
            <label htmlFor='userGradeEleven'>11학년</label>
          </div>
        </div>
      </div>

      <div className='mt-4 mb-4'>
        <label htmlFor="userEmailStudent" className="form-label required mb-3">4. 연락처(이메일주소)</label>

        <div className="input-group mb-2">
          <input type="email" {...register("userEmailStudent")} id="userEmailStudent" className="form-control" maxLength={50} autoComplete='off' required placeholder='학생 이메일 주소를 입력해주세요.' />
        </div>
        <div className="input-group mb-5">
          <input type="email" {...register("userEmailParent")} id="userEmailParent" className="form-control" maxLength={50} autoComplete='off' placeholder='보호자 이메일 주소를 입력해주세요.' />
        </div>
      </div>

      <div className='mb-4'>
        <label className="form-label required mb-3">5. 한국대학 지원자격</label>
        <div className="input-group mb-5">
          <div className="me-5">
            <input type="radio" value={'12년특례'} {...register('applyType')} id='applyType1' className="form-check-input mt-0 me-2" required />
            <label htmlFor='applyType1'>12년특례</label>
          </div>
          <div className="me-5">
            <input type="radio" value={'3년특례'} {...register('applyType')} id='applyType2' className="form-check-input mt-0 me-2" required />
            <label htmlFor='applyType2'>3년특례</label>
          </div>
          <div className="me-5">
            <input type="radio" value={'수시 전형'} {...register('applyType')} id='applyType3' className="form-check-input mt-0 me-2" required />
            <label htmlFor='applyType3'>수시 전형</label>
          </div>
          <div className="me-5">
            <input type="radio" value={'잘 모르겠음'} {...register('applyType')} id='applyType4' className="form-check-input mt-0 me-2" required />
            <label htmlFor='radio-2-4'>잘 모르겠음</label>
          </div>
        </div>
      </div>

      <div className='mb-4'>
        <label htmlFor='hopeUniversity1' className="form-label required mb-3">6. 한국대학 희망대학</label>
        {/* ✏️ */}
        <div className="input-group mb-2">
          <input type="text" {...register('hopeUniversity1')} id="hopeUniversity1" className="form-control" placeholder='희망하는 대학을 입력해주세요.' maxLength={50} autoComplete='off' required />
        </div>
        <div className="input-group mb-2">
          <input type="text" {...register('hopeUniversity2')} id="hopeUniversity2" className="form-control" placeholder='희망하는 대학을 입력해주세요.' maxLength={50} autoComplete='off' />
        </div>
        <div className="input-group mb-5">
          <input type="text" {...register('hopeUniversity3')} id="hopeUniversity3" className="form-control" placeholder='희망하는 대학을 입력해주세요.' maxLength={50} autoComplete='off' />
        </div>
        {/* {fields.map((field, index) => (
          <div key={field.id} className="input-group mb-2">
            <input
              type="text"
              {...register(`universities.${index}.name`)}
              className="form-control"
              placeholder="희망하는 대학을 입력해주세요."
              maxLength={50}
              autoComplete="off"
            />
            <button type="button" onClick={() => remove(index)}>삭제</button>
          </div>
        ))} */}
        {/* <div>
          <button type="button" onClick={() => append({ name: "" })}>대학 추가</button>
        </div> */}
      </div>

      <div className='mb-4'>
        <label htmlFor='hopeMajor1' className="form-label required mb-3">7. 한국대학 희망전공, 계열</label>
        <div className="input-group mb-2">
          <input type="text" {...register('hopeMajor1')} id="hopeMajor1" className="form-control" placeholder='희망하는 전공 또는 계열을 입력해주세요.' maxLength={50} autoComplete='off' required />
        </div>
        <div className="input-group mb-2">
          <input type="text" {...register('hopeMajor2')} id="hopeMajor2" className="form-control" placeholder='희망하는 전공 또는 계열을 입력해주세요.' maxLength={50} autoComplete='off' />
        </div>
        <div className="input-group mb-5">
          <input type="text" {...register('hopeMajor3')} id="hopeMajor3" className="form-control" placeholder='희망하는 전공 또는 계열을 입력해주세요.' maxLength={50} autoComplete='off' />
        </div>
      </div>

      <div className='mb-4'>
        <label className="form-label required mb-2">8. 학교 성적(GPA) &nbsp;(성적표 업로드 필수)</label>

        <div className='mb-1'><span className='font-size-sm'>(9학년부터 현재 학년까지 최근 성적을 모두 입력해주세요.)</span></div>
        <div className='mb-3'><span className='font-size-sm'>(아래 첨부파일란에 성적표를 업로드 해주세요.)</span></div>

        <div className="d-flex input-group mb-2">
          <input type="text" {...register('gpaGrade1')} id="gpaGrade1" className="form-control" placeholder='학년을 입력해주세요.' maxLength={50} autoComplete='off' required />
          <input type="text" {...register('gpaValue1')} id="gpaValue1" className="form-control" placeholder='성적(GPA)을 입력해주세요.' maxLength={50} autoComplete='off' required />
        </div>
        <div className="d-flex input-group mb-2">
          <input type="text" {...register('gpaGrade2')} id="gpaGrade2" className="form-control" placeholder='학년을 입력해주세요.' maxLength={50} autoComplete='off' />
          <input type="text" {...register('gpaValue2')} id="gpaValue2" className="form-control" placeholder='성적(GPA)을 입력해주세요.' maxLength={50} autoComplete='off' />
        </div>
        <div className="d-flex input-group mb-5">
          <input type="text" {...register('gpaGrade3')} id="gpaGrade3" className="form-control" placeholder='학년을 입력해주세요.' maxLength={50} autoComplete='off' />
          <input type="text" {...register('gpaValue3')} id="gpaValue3" className="form-control" placeholder='성적(GPA)을 입력해주세요.' maxLength={50} autoComplete='off' />
        </div>
      </div>

      <div className='mb-4'>
        <label htmlFor='introduce' className="form-label required mb-3">9. '나'라는 사람은 어떤 사람인가요? (간단하게)</label>
        <div className="input-group mb-2">
          <textarea {...register('introduce')} id='introduce' className="form-control" rows={8} maxLength={1000} required />
        </div>
      </div>

      <div className='mb-4'>
        <label htmlFor='achievement' className="form-label required mb-3">10. 본인이 가장 자랑스러워하는 성취는 무엇이며, 그 성취를 통해 배운 점은 무엇인가요?</label>
        <div className="input-group mb-2">
          <textarea {...register('achievement')} id='achievement' className="form-control" rows={8} maxLength={1000} required />
        </div>
      </div>

      <div className='mb-4'>
        <label htmlFor='difficulty' className="form-label required mb-3">11. 당신이 직면했던 가장 큰 어려움이나 도전은 무엇이었으며, 그것을 어떻게 극복했나요?</label>
        <div className="input-group mb-2">
          <textarea {...register('difficulty')} id='difficulty' className="form-control" rows={8} maxLength={1000} required />
        </div>
      </div>

      <div className='mb-4'>
        <label htmlFor='respect' className="form-label required mb-3">12. 가장 존경하는 인물은 누구이며, 그 이유는 무엇인가요?</label>
        <div className="input-group mb-2">
          <textarea {...register('respect')} id='respect' className="form-control" rows={8} maxLength={1000} required />
        </div>
      </div>

      <div className='mb-4'>
        <label htmlFor='goals' className="form-label required mb-3">13. 인생에서 이루고 싶은 목표가 있다면 무엇이고, 그 목표를 달성하기 위해 어떤 계획을 세우고 있나요?</label>
        <div className="input-group mb-2">
          <textarea {...register('goals')} id='goals' className="form-control" rows={8} maxLength={1000} required />
        </div>
      </div>

      <hr className='mt-5 mb-5' />

      <div className='mb-4'>
        <p className='text-primary'>아래 문항부터는 선택 입력 항목입니다.</p>
      </div>

      <div className='mb-4'>
        <label className="form-label mb-2">14. 공인 성적 (성적표 업로드)</label>
        <div className='mb-3'><span className='font-size-sm'>(아래 첨부파일란에 성적표를 업로드 해주세요.)</span></div>
        <div className='sub-section mb-4'>
          <label htmlFor='languageTestName1' className="form-label mb-3">14-1. 공인 어학 성적 (TOEFL, IETLS 등)</label>

          <div className="d-flex input-group mb-2">
            <input type="text" {...register('languageTestName1')} id="languageTestName1" className="form-control" placeholder='시험이름을 입력해주세요.' maxLength={50} autoComplete='off' />
            <input type="text" {...register('languageTestValue1')} id="languageTestValue1" className="form-control" placeholder='점수를 입력해주세요.' maxLength={50} autoComplete='off' />
          </div>
          <div className="d-flex input-group mb-2">
            <input type="text" {...register('languageTestName2')} id="languageTestName2" className="form-control" placeholder='시험이름을 입력해주세요.' maxLength={50} autoComplete='off' />
            <input type="text" {...register('languageTestValue2')} id="languageTestValue2" className="form-control" placeholder='점수를 입력해주세요.' maxLength={50} autoComplete='off' />
          </div>
          <div className="d-flex input-group mb-2">
            <textarea {...register('languageTestAnother')} id='languageTestAnother' className="form-control" rows={4} maxLength={500} placeholder='추가로 작성할 공인 어학 시험의 시험이름과 점수를 입력해주세요.' />
          </div>
        </div>

        <div className='sub-section mb-4'>
          <label htmlFor='standardTestName1' className="form-label mb-3">14-2. 표준화 학력 시험 (SAT, AP 등)</label>

          <div className="d-flex input-group mb-2">
            <input type="text" {...register('standardTestName1')} id="standardTestName1" className="form-control" placeholder='시험이름을 입력해주세요.' maxLength={250} autoComplete='off' />
            <input type="text" {...register('standardTestValue1')} id="standardTestValue1" className="form-control" placeholder='점수를 입력해주세요.' maxLength={250} autoComplete='off' />
          </div>
          <div className="d-flex input-group mb-2">
            <input type="text" {...register('standardTestName2')} id="standardTestName2" className="form-control" placeholder='시험이름을 입력해주세요.' maxLength={250} autoComplete='off' />
            <input type="text" {...register('standardTestValue2')} id="standardTestValue2" className="form-control" placeholder='점수를 입력해주세요.' maxLength={250} autoComplete='off' />
          </div>
          <div className="d-flex input-group mb-2">
            <textarea {...register('standardTestAnother')} id='standardTestAnother' className="form-control" rows={4} maxLength={500} placeholder='추가로 작성할 표준화 학력 시험의 시험이름과 점수를 입력해주세요.' />
          </div>
        </div>

        <div className='sub-section mb-4'>
          <label htmlFor='etcTestName1' className="form-label mb-3">14-3. 기타 공인 성적 (제2외국어 등)</label>
          <div className="d-flex input-group mb-2">
            <input type="text" {...register('etcTestName1')} id="etcTestName1" className="form-control" placeholder='시험이름을 입력해주세요.' maxLength={50} autoComplete='off' />
            <input type="text" {...register('etcTestValue1')} id="etcTestValue1" className="form-control" placeholder='점수를 입력해주세요.' maxLength={50} autoComplete='off' />
          </div>
          <div className="d-flex input-group mb-2">
            <input type="text" {...register('etcTestName2')} id="etcTestName2" className="form-control" placeholder='시험이름을 입력해주세요.' maxLength={50} autoComplete='off' />
            <input type="text" {...register('etcTestValue2')} id="etcTestValue2" className="form-control" placeholder='점수를 입력해주세요.' maxLength={50} autoComplete='off' />
          </div>
          <div className="d-flex input-group mb-2">
            <textarea {...register('etcTestAnother')} id='etcTestAnother' className="form-control" rows={4} maxLength={500} placeholder='추가로 작성할 기타 공인 성적의 시험이름과 점수를 입력해주세요.' />
          </div>
        </div>
      </div>

      <div className='mb-4'>
        <label htmlFor='club1' className="form-label mb-3">15. 주요 동아리 활동</label>
        <div className="input-group mb-2">
          <input type="text" {...register('club1')} id="club1" className="form-control" placeholder='동아리 활동을 입력해주세요.' maxLength={100} autoComplete='off' />
        </div>
        <div className="input-group mb-2">
          <input type="text" {...register('club2')} id="club2" className="form-control" placeholder='동아리 활동을 입력해주세요.' maxLength={100} autoComplete='off' />
        </div>
        <div className="input-group mb-2">
          <input type="text" {...register('club3')} id="club3" className="form-control" placeholder='동아리 활동을 입력해주세요.' maxLength={100} autoComplete='off' />
        </div>
      </div>

      <div className='mb-4'>
        <label htmlFor='award1' className="form-label mb-3">16. 주요 수상 실적</label>
        <div className="input-group mb-2">
          <input type="text" {...register('award1')} id="award1" className="form-control" placeholder='수상 실적을 입력해주세요.' maxLength={100} autoComplete='off' />
        </div>
        <div className="input-group mb-2">
          <input type="text" {...register('award2')} id="award2" className="form-control" placeholder='수상 실적을 입력해주세요.' maxLength={100} autoComplete='off' />
        </div>
        <div className="input-group mb-2">
          <input type="text" {...register('award3')} id="award3" className="form-control" placeholder='수상 실적을 입력해주세요.' maxLength={100} autoComplete='off' />
        </div>
      </div>

      <div className='mb-4'>
        <label htmlFor='leadership1' className="form-label mb-3">17. 리더십 활동</label>
        <div className="input-group mb-2">
          <input type="text" {...register('leadership1')} id="leadership1" className="form-control" placeholder='리더십 활동을 입력해주세요.' maxLength={100} autoComplete='off' />
        </div>
        <div className="input-group mb-2">
          <input type="text" {...register('leadership2')} id="leadership2" className="form-control" placeholder='리더십 활동을 입력해주세요.' maxLength={100} autoComplete='off' />
        </div>
        <div className="input-group mb-2">
          <input type="text" {...register('leadership3')} id="leadership3" className="form-control" placeholder='리더십 활동을 입력해주세요.' maxLength={100} autoComplete='off' />
        </div>
      </div>

      <div className='mb-4'>
        <label htmlFor='question' className="form-label mb-3">18. 한국대학 입시관련 궁금한 점</label>
        <div className="input-group mb-2">
          <textarea {...register('question')} id='question' className="form-control" rows={8} maxLength={500} />
        </div>
      </div>

      <div className='mb-4'>
        <label htmlFor='files' className="form-label mb-3">19. 첨부파일 업로드 (1.학교성적표, 2.어학성적표, 3.표준화학력시험 성적표, 4.기타공인성적 성적표, 5.동아리, 수상실적)</label>
        <input type='file' ref={fileInputRef} id='files' className='d-none' onChange={handleFileInputChange} multiple />
        <div className='files-section'>

          <ul className='file-list mb-4'>
            {(savedFiles && savedFiles.length > 0) && <SavedFileList files={savedFiles} onClickDeleteSavedFile={onClickDeleteSavedFile} />}

            <hr />

            {/* {(files && files.length > 0) && <InputFileList files={files} onClickDeleteFile={onClickDeleteFile} />} */}
            {(newFiles && newFiles.length > 0) && <InputFileList files={newFiles} onClickDeleteFile={onClickDeleteFile} />}
          </ul>
          <label htmlFor='files' className='btn btn-secondary'>파일선택</label>
        </div>
      </div>

      <div className='mt-5 text-center'>
        {/* <button className='btn btn-secondary'>⚽ 임시저장</button> */}
        {/* &nbsp;&nbsp; */}
        <button className='btn btn-primary'>제출하기</button>
      </div>

    </form>
  )
}


const SavedFileList = ({ files, onClickDeleteSavedFile }) => {
  return files.map((file, index) => (<SavedFileItem key={'saved-file-item-' + index} file={file} index={index} onClickDeleteSavedFile={onClickDeleteSavedFile} />))
}

const SavedFileItem = ({ file, index, onClickDeleteSavedFile }) => {
  const fileName = getFileName('survey', file)

  return (
    <li key={'fileItem' + index} className='file-list__item'>
      <div className='file-list__filename'>
        <a href={file} download={fileName} className='download-link'><FaFileAlt /> {fileName}</a>
      </div>
      <div className='file-list__button'>
        <button type='button' className='btn btn-sm text-danger' onClick={() => onClickDeleteSavedFile(file)}>X</button>
      </div>
    </li>
  )
}

const InputFileList = ({ files, onClickDeleteFile }) => {
  return Array.from(files).map((file, index) => <FileItem key={'file-item-' + index} file={file} index={index} onClickDeleteFile={onClickDeleteFile} />)
}

const FileItem = ({ file, index, onClickDeleteFile }) => {
  return (
    <li key={'fileItem' + index} className='file-list__item'>
      <div className='file-list__filename'><FaFileAlt />&nbsp;{file.name}</div>
      <div className='file-list__button'>
        <button type='button' className='btn btn-sm text-danger' onClick={() => onClickDeleteFile(index)}>X</button>
      </div>
    </li>
  )
}

export default SurveyForm